import Statuses from '@/orm/models/Candidate/Statuses';
import { computed } from '@vue/composition-api';

export default function useStatus() {
  const statuses = computed(() => Statuses.query().withAllRecursive().get());

  async function fetchAllStatuses() {
    return Statuses.api().fetchAllStatuses();
  }

  return {
    statuses,
    fetchAllStatuses,
  };
}
